// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"74b0f240cf2bf357e5b7","5338":"84cc9bc211fe652e105d"}[chunkId] + ".js";
};